import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=4dff6240&scoped=true&"
import script from "./SupportButton.vue?vue&type=script&lang=ts&"
export * from "./SupportButton.vue?vue&type=script&lang=ts&"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=4dff6240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff6240",
  null
  
)

export default component.exports